export const NINETH_ANNIVERSARY_ACT = 52000; // 九周年
export const PC_XL_ACT = 52001; // PCXL
export const NAS_PLANET_ACT = 52002; //纳思星球

export const ACT_NAME_MAP = {
  [NINETH_ANNIVERSARY_ACT]: '网心云9周年',
  [PC_XL_ACT]: '迅雷PC版',
  [NAS_PLANET_ACT]: '纳思星球',
};

export const ACT_DESC_MAP = {
  [NINETH_ANNIVERSARY_ACT]: '购机赢迅雷会员年卡资格',
  [PC_XL_ACT]: '长期得迅雷超级会员周卡',
  [NAS_PLANET_ACT]: '在线达标得迅雷超级会员月卡',
};

export const ACT_BUTTON_TEXT_MAP = {
  [NINETH_ANNIVERSARY_ACT]: '查看详情',
  [PC_XL_ACT]: '在线记录',
  [NAS_PLANET_ACT]: '在线达标记录',
};

// 迅雷会员卡状态-待领取
export const REWARD_UNRECEIVE_STATUS = 1;
// 迅雷会员卡状态-已领取
export const REWARD_RECEIVED_STATUS = 2;
// 迅雷会员卡状态-已失效
export const REWARD_EXPIRED_STATUS = 3;

export const REWARD_BUTTON_TEDXT_MAP = {
  [REWARD_UNRECEIVE_STATUS]: '立即领取',
  [REWARD_RECEIVED_STATUS]: '已领取',
  [REWARD_EXPIRED_STATUS]: '已失效',
};

export const MODAL_CONTENT = {
  onlineDays_52001: {
    title: '打卡天数达标要求',
    content: `需满足在线时间与带宽贡献要求。\n① 每日在线≥10个小时；\n② 每日晚高峰18点-24点的平均贡献带宽≥6M；\n③ 每日晚高峰18点-24点100%在线；`,
  },
  onlineDays_52002: {
    title: '打卡天数达标要求',
    content: `需满足在线时间与带宽贡献要求。\n① 每日在线≥20个小时；\n② 每日晚高峰18点-24点的平均跑量≥20M；\n③ 使用网络为移动、联通、电信三大运营商之一；`,
  },
};

// 每天达标状态
// 未达标
export const DAY_NOT_MEET_STATUS = 0;
// 达标
export const DAY_MEET_STATUS = 1;
// 已退出
export const DAY_QUIT_STATUS = 2;

export const TIME_FORMAT = 'YYYY-MM';
export const DEFAULT_TEXT = '--';

export const MEET_STATUS_OPTIONS = [
  {
    value: DAY_MEET_STATUS,
    label: '已达标',
  },
  {
    value: DAY_NOT_MEET_STATUS,
    label: '未达标',
  },
];

export const DEFAULT_CALENDAR_ITEM = {
  day: '',
  d: '',
  s: -1,
  fr: '',
};

// 未达标原因：在线时长不足
export const DEVICE_NOT_MEET_REASON_ONLINE = '1';
// 未达标原因：晚高峰
export const DEVICE_NOT_MEET_REASON_PEAK = '2';
// 未达标原因：晚高峰带宽
export const DEVICE_NOT_MEET_REASON_WD = '3';

export const EMPTY_DATA_MAP = {
  udl: `当前暂无待领取的迅雷超级会员\n快去努力达标吧～`,
  rdl: '暂无已领取的迅雷超级会员',
  edl: '暂无已失效的迅雷超级会员',
};
